// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"73a353d6","511":"0e2343be","819":"63e74f5c"}[chunkId] + ".chunk.js";
};